import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

function ArsenalDay({ currentDate, setCurrentDate }) {

    // Check if we can decrement or increment the date (only weekdays allowed)
    const canDecrement = currentDate.getDay() > 1;
    const canIncrement = currentDate.getDay() < 5;


    // Function to modify the date (increment or decrement)
    const updateDate = (direction) => {
        const newDate = new Date(currentDate);
        newDate.setDate(newDate.getDate() + direction);
        if (newDate.getDay() >= 1 && newDate.getDay() <= 5) {
            setCurrentDate(newDate);
        }
    }

    return (
        <div className="meal-day">
            {/* Decrement button */}
            <button onClick={() => updateDate(-1)}>
                <FontAwesomeIcon icon={faAngleLeft} size="lg" style={{ visibility: canDecrement ? 'visible' : 'hidden' }} />
            </button>

            <p className="actual-day">
                <span>
                    {currentDate.toLocaleDateString('fr-FR', {
                        weekday: 'long',
                    })}
                </span>
                <span>
                    {currentDate.toLocaleDateString('fr-FR', {
                        day: 'numeric',
                        month: 'numeric',
                    })}
                </span>
            </p>
             {/* Increment button */}
            <button onClick={() => updateDate(1)}>
                <FontAwesomeIcon icon={faAngleRight} size="lg" style={{ visibility: canIncrement ? 'visible' : 'hidden' }} />
            </button>
        </div>
    );
}

ArsenalDay.propTypes = {
    currentDate: PropTypes.instanceOf(Date).isRequired,
    setCurrentDate: PropTypes.func.isRequired,
};

export default ArsenalDay;
